<template>
  <div v-show="mode == MonthYearDisplayMode.MonthAndYear" class="col-sm-8">
    <select-list
      ref="monthList"
      :label="monthLabel"
      :ariaLabel="ariaMonthLabel"
      :items="getMonths()"
      @change="onMonthChange"
      class="mb-4 mb-sm-0"
    ></select-list>
  </div>
  <div class="col-sm-4">
    <select-list
      ref="yearList"
      :label="yearLabel"
      :ariaLabel="ariaYearLabel"
      :items="getYears"
      @change="onYearChange"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import SelectList from "../../../shared/components/SelectList.vue";
import ListItem from "@/shared/ts/listItem";
import MonthYearDisplayMode from "@/guiide/ts/components/MonthYearDisplayMode";
import dateTimeProvider from "@/guiide/ts/systemDateTimeProvider";

export default defineComponent({
  name: "MonthAndYear",
  emits: ["change"],
  props: {
    monthLabel: { type: String, required: true },
    yearLabel: { type: String, required: true },
    defaultYearRange: { type: Number, default: 10, required: false },
    mode: { default: MonthYearDisplayMode.MonthAndYear, required: false },
    ariaMonthLabel: { type: String, required: true },
    ariaYearLabel: { type: String, required: true }
  },
  components: {
    SelectList
  },
  setup() {
    const monthList = ref(null);
    const yearList = ref(null);
    const startYear = ref(dateTimeProvider.now().getFullYear());
    const lastYear = ref(startYear.value + 15);

    return {
      monthList,
      yearList,
      startYear,
      lastYear,
      MonthYearDisplayMode
    };
  },
  methods: {
    setFirstYear(year: number) {
      const lastYear = year + this.defaultYearRange;
      this.setFirstAndLastYear(year, lastYear);
    },
    setFirstAndLastYear(startYear: number, lastYear: number) {
      const currentYear = this.yearList.getSelectedValue();
      if (
        currentYear != null &&
        (currentYear < startYear || currentYear > lastYear)
      ) {
        this.yearList.setSelectedValue(1);
      }

      this.startYear = startYear;
      this.lastYear = lastYear;
    },
    setSelectedValue(month: string, year: string) {
      this.monthList.setSelectedValue(month);
      this.yearList.setSelectedValue(year);
    },
    setDisabledState(value: boolean) {
      this.monthList.setDisabledState(value);
      this.yearList.setDisabledState(value);
    },
    onMonthChange() {
      this.$emit("change");
    },
    onYearChange() {
      this.$emit("change");
    },
    getSelectedMonth() {
      return this.monthList.getSelectedValue();
    },
    getSelectedYear() {
      return this.yearList.getSelectedValue();
    },
    getSelectedDate(): Date | null {
      const retirementMonth = this.getSelectedMonth();
      const retirementYear = this.getSelectedYear();

      if (retirementMonth == "" || retirementYear == "") {
        return null;
      }

      if (retirementYear < this.startYear || retirementYear > this.lastYear) {
        return null;
      }

      const retirementMonthName = this.getMonthName(retirementMonth);

      return new Date(`1 ${retirementMonthName} ${retirementYear}`);
    },
    getMonths(): Array<ListItem> {
      const items = new Array<ListItem>();

      items.push(new ListItem("January", "1"));
      items.push(new ListItem("February", "2"));
      items.push(new ListItem("March", "3"));
      items.push(new ListItem("April", "4"));
      items.push(new ListItem("May", "5"));
      items.push(new ListItem("June", "6"));
      items.push(new ListItem("July", "7"));
      items.push(new ListItem("August", "8"));
      items.push(new ListItem("September", "9"));
      items.push(new ListItem("October", "10"));
      items.push(new ListItem("November", "11"));
      items.push(new ListItem("December", "12"));

      return items;
    },
    getMonthName(monthNumber: number): string {
      const months = this.getMonths();
      return months.filter(m => m.value == monthNumber)[0].text;
    }
  },
  computed: {
    getYears: function(): Array<ListItem> {
      const items = new Array<ListItem>();

      const currentYear = this.startYear;
      const finalYear = this.lastYear;

      for (let i: number = currentYear; i <= finalYear; i++) {
        items.push(new ListItem(i.toString(), i.toString()));
      }

      return items;
    }
  }
});
</script>
